import { QueryInterface } from './query';

export const getGrossSum = (data: QueryInterface) => {
  const { value: valueBnh } = data.bnh.positionsSummary.grossUnrealizedPnlSum;
  const { value: valueLimited } = data.limited.positionsSummary.grossUnrealizedPnlSum;
  const { value: valueUnlimited } = data.unlimited.positionsSummary.grossUnrealizedPnlSum;
  const { value: valueStocks } = data.stocks.positionsSummary.grossUnrealizedPnlSum;

  return +valueBnh + +valueLimited + +valueUnlimited + +valueStocks;
};

export const getInvestSum = (data: QueryInterface) => {
  const { value: valueBnh } = data.bnh.positionsSummary.investmentSum;
  const { value: valueLimited } = data.limited.positionsSummary.investmentSum;
  const { value: valueUnlimited } = data.unlimited.positionsSummary.investmentSum;
  const { value: valueStocks } = data.stocks.positionsSummary.investmentSum;

  return +valueBnh + +valueLimited + +valueUnlimited + +valueStocks;
};
